import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../components/loading';
import * as api from '../service/api'
import io from 'socket.io-client'
import Media from 'react-media';



function DeviceManager() {
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const [dispositivos, setDispositivos] = useState([])

    useEffect(() => {
        buscarDispositivos()
    }, [])

    const buscarDispositivos = () => {
        setLoading(true)
        setTimeout(() => {
            api.dispositivos()
                .then(res => {
                    if (!res.success) {
                        if (res.code == 0) {
                            history.replace('/logout')
                        }
                        return
                    }
                    setLoading(false)
                    setDispositivos(res.dispositivos)
                })
        }, 500);
    }

    const removerDispositivo = (id) => {
        setLoading(true)
        api.removerDispositivo(id)
            .then(res => {
                if (!res.success) {
                    if (res.code == 0) {
                        history.replace('/logout')
                    }
                    setLoading(false)
                    return
                }

                let socket = io(api.SOCKET_FLUSSONIC)
                socket.on('connect', () => {
                    socket.emit('deactivation', res)
                    socket.disconnect()

                })

                buscarDispositivos()
            })
    }

    return (
        <div className="container mx-auto pt-10 pb-16 px-4">
            <div className="flex justify-between items-center mb-3">
                <div>
                    <h1 className="text-3xl font-bold">Meus dispositivos</h1>
                    <p className="text-sm text-gray-400 mt-1">Gerencie os dispositivos vinculados à sua conta</p>
                </div>
                <Link to="/app/account" className="text-sm text-blue-400 hover:text-blue-300 hover:underline">← Voltar</Link>
            </div>
            <hr className="border-orange-700 mb-6" />

            <Media query="(max-width: 599px)" render={() =>
            (
                <div>
                    {loading ?
                        <Loading />
                        : dispositivos.length == 0
                            ? (<div className="mt-10 text-center"><span className="text-xl text-gray-500">Nenhum dispositivo cadastrado</span></div>)
                            : dispositivos.map((dispositivo, index) => (
                                <div key={index} className="flex flex-col bg-gray-800 border border-gray-700 rounded-lg my-3 p-4 gap-1">
                                    <span className="font-medium text-white">{dispositivo.modelo}</span>
                                    <span className="text-sm text-gray-400">{dispositivo.tipo}</span>
                                    <span className="text-sm text-gray-400">Último acesso: {dispositivo.horario_formatado}</span>
                                    <button onClick={() => removerDispositivo(dispositivo.id)} className="mt-2 bg-red-600 hover:bg-red-700 text-white text-sm px-3 py-1 rounded w-fit">
                                        <i className="fa fa-remove mr-1" /> Remover
                                    </button>
                                </div>
                            ))
                    }
                </div>
            )} />

            <Media query="(min-width: 600px)" render={() =>
            (
                <div>
                    {loading ?
                        <Loading />
                        :
                        dispositivos.length == 0
                            ? (<div className="mt-10 text-center"><span className="text-xl text-gray-500">Nenhum dispositivo cadastrado</span></div>)
                            :
                            <table className="min-w-full table-auto">
                                <thead>
                                    <tr className="bg-gray-800 text-left text-sm text-gray-400">
                                        <th className="py-3 px-4">#</th>
                                        <th className="py-3 px-4">Dispositivo</th>
                                        <th className="py-3 px-4">Tipo</th>
                                        <th className="py-3 px-4">Último acesso</th>
                                        <th className="py-3 px-4">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dispositivos.map((dispositivo, index) => (
                                        <tr key={index} className="border-b border-gray-700 hover:bg-gray-800 transition-colors">
                                            <td className="py-3 px-4 text-sm text-gray-500">{index + 1}</td>
                                            <td className="py-3 px-4 font-medium text-white">{dispositivo.modelo}</td>
                                            <td className="py-3 px-4 text-sm text-gray-400">{dispositivo.tipo}</td>
                                            <td className="py-3 px-4 text-sm text-gray-400">{dispositivo.horario_formatado}</td>
                                            <td className="py-3 px-4">
                                                <button onClick={() => removerDispositivo(dispositivo.id)} className="bg-red-600 hover:bg-red-700 text-white text-sm px-3 py-1 rounded">
                                                    <i className="fa fa-remove mr-1" /> Remover
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    }
                </div>
            )} />

        </div>
    )
}

export default DeviceManager;